import {call, fork, put, takeEvery} from "redux-saga/effects";
import { Storage, ToStorage,} from "./storage";
import {setPlayedItem} from "../../Store/playedItem";
import {ApiClient} from "../../../generated/ApiClient";
import {FrontWebPodcastEpisodeModel, FrontWebRadioModel} from "../../../generated";
import {slugifyPath} from "../../../utils/slugifyPath";
import { slugifyParse} from "./slugifyParse";

export function* playedItem() {

    // eslint-disable-next-line
    yield takeEvery<ReturnType<typeof setPlayedItem>>("playedItem/setPlayedItem",  function * (action) {
        if (!action.payload) {
            ToStorage("rczplayed", undefined);
        } else {
            ToStorage("rczplayed", slugifyPath(action.payload));
        }
        return
    });

    yield fork(Storage, "rczplayed", function * (value: any) {
        if (typeof value === "string") {
            const v= value as string;
            const item = slugifyParse(v);
            let radio: FrontWebRadioModel| null = null;
            let episode: FrontWebPodcastEpisodeModel | null = null;
            if ("radioSlug" in item) {
                radio = yield call(async () => {
                    try {
                        return new ApiClient().getApiRadioDetail({
                            slug: item.radioSlug
                        });
                    }
                    catch (e) {
                        return null;
                    }
                });

            }

            if ("id" in item) {
                episode = yield call(async () => {
                    try {
                        return new ApiClient().getApiPodcastEpisode({
                            programSlug: item.programSlug,
                            id: item.id
                        }, {
                            credentials: "include"
                        });
                    }
                    catch (e) {
                        return null;
                    }
                });
            }

            if (episode && radio) {
                yield put(setPlayedItem({
                    radioSlug: radio.slug,
                    radioName: radio.name,
                    name: episode.name,
                    id: episode.id,
                    programSlug: episode.programSlug,
                    programName: episode.programName,
                    image: episode.image,
                    duration: episode.duration,
                    playedItemType: true
                }));
            } else if (episode) {
                yield put(setPlayedItem({
                    name: episode.name,
                    id: episode.id,
                    image: episode.image,
                    programSlug: episode.programSlug,
                    programName: episode.programName,
                    duration: episode.duration,
                    playedItemType: true
                }));
            } else if (radio) {
                yield put(setPlayedItem({
                    radioSlug: radio.slug,
                    radioName: radio.name,
                    image: radio.logo,
                    radioSlogan: radio.slogan,
                    playedItemType: true
                }));
            }


        }
    });

}